const ROLODEX_ENTRIES_LOAD_PATH = '/api/v2/entries/load'
const ROLODEX_ENTRIES_HISTOGRAM_PATH = '/api/v2/entries/histogram'

type SWRKey = string | ReadonlyArray<string | number> | null | false | undefined

export function isRolodexEntriesLoadSWRKey(key: SWRKey): boolean {
  if (!Array.isArray(key) || key.length < 1) return false
  const endpoint = key[0]
  return (
    typeof endpoint === 'string' && endpoint.includes(ROLODEX_ENTRIES_LOAD_PATH)
  )
}

function isHistogramQueryBody(body: string): boolean {
  try {
    const parsed = JSON.parse(body)
    return (
      typeof parsed === 'object' &&
      parsed !== null &&
      !Array.isArray(parsed) &&
      'select' in parsed
    )
  } catch {
    return false
  }
}

export function isRolodexHistogramSWRKey(key: SWRKey): boolean {
  if (!Array.isArray(key) || key.length < 1) return false
  const first = key[0]
  if (typeof first !== 'string') return false
  if (first.includes(ROLODEX_ENTRIES_HISTOGRAM_PATH)) return true
  if (!first.startsWith('{')) return false
  return isHistogramQueryBody(first)
}

export function isRolodexBrowseInvalidationSWRKey(key: SWRKey): boolean {
  return isRolodexEntriesLoadSWRKey(key) || isRolodexHistogramSWRKey(key)
}
